

import React, { useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider
} from "@mui/material";
import CustomText, { textStyles } from "../../../../components/CustomText";
import profilecross from "../../../../assets/profilecross.svg";
// import StripeIcon from "../../../../assets/stripe.svg";
// import PaypalIcon from "../../../../assets/paypal.svg";
import company from "../../../../assets/Wallet/company.png";
import invited from '../../../../assets/Dashboard/invited.svg';
import stripe from "../../../../assets/Wallet/stripe.svg";
import paypal from "../../../../assets/Wallet/paypal.svg";
import receipt from "../../../../assets/Wallet/receipt.svg";
import view from "../../../../assets/Wallet/view.png"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import paid from "../../../../assets/Wallet/paid.svg";
import process from "../../../../assets/Wallet/process.svg";
import request from "../../../../assets/Wallet/request.svg";
import overdue from "../../../../assets/Wallet/overdue.svg";
import down from "../../../../assets/down.svg";
import received from "../../../../assets/Wallet/received.svg";
import pending from "../../../../assets/Wallet/pending.svg";
import inactive from "../../../../assets/Dashboard/inactive.svg";
import expire from "../../../../assets/expire.svg";
import trial from "../../../../assets/Dashboard/trial.svg";
import code from "../../../../assets/code.svg";
import CustomButton from "../../../../components/CustomButton";
import active from "../../../../assets/Dashboard/active.svg";
import { useTranslation } from "react-i18next";
import StatusDropdown from "../../../../components/StatusDropdown";
import { formatNumber } from "../../../../Utlis/formatNumber";
const CommissionDetails = ({ open, onClose, selectedRow }) => {
  useEffect(() => {}, [selectedRow]);

    
const statusIcons = {
  Active: active,
  Trial: trial,
  Invited: invited,
  Inactive: inactive,
  Requested: request,
  Overdue:overdue,
   Processing:process,
   Paid:active,
   Pending:pending,
    Received:received,
      pending:pending,
    received:received

};

const statusStyles = {
  Active: { backgroundColor: '#4BCE97', color: '#164B35' },
  Trial: { backgroundColor: '#FEA362', color: '#702E00' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' },
  Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
    Paid: { backgroundColor: '#4CD08B', color: '#0E563F' },
  Processing: { backgroundColor: '#FDD35C', color: '#7A4100' },
  Overdue: {backgroundColor: '#FFA26B', color: '#722800' },
   Pending: {  backgroundColor: '#F5CD47',  color: '#533F04', },
    Received: {  backgroundColor: '#4BCE97', color: '#164B35',  },
     pending: {  backgroundColor: '#F5CD47',  color: '#533F04', },
    received: {  backgroundColor: '#4BCE97', color: '#164B35',  }
};
const { t } = useTranslation();
useEffect(() => {
  console.log("Selected Row in Drawer:", selectedRow);
}, [selectedRow]);

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{
    sx: {
      width: {
        xs: '100%',
        sm: 400,
        md: 500
      }
    }
  }}>
      <Box sx={{ position: 'sticky', top: 0, backgroundColor: '#E7EBEE', zIndex: 10, px: 2, py: 1, borderBottom: '1px solid #E4E6EF' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: '#2C384C' }}>
            {/* ID#{selectedRow?.id || '----'} */}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px:2,py:3,  backgroundColor: 'white' }}>
        <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 600, color: '#2C384C', textAlign: 'left', pb: 1 }}>
        {t("commissionDetails.subscriptionDetails")}
        </CustomText>
        <Box sx={{ border: '1px solid #E4E6EF', borderRadius: 2, p: 2, backgroundColor: '#fff',mt:2, mb: 3 }}>
          {/* <Box sx={{ display: 'flex', justifyContent: 'Center', alignItems: 'center' }}>
            
            <img src={company} alt="method" width={120} height={120} />
          </Box> */}
 
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
    {t("commissionDetails.subscriptionStatus")}
  </CustomText>

                                              <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow?.status|| "pending"}
      />
    </Box>
</Box>
               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.subscription")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
{/* {selectedRow?.subscription} */}
      {Array.isArray(selectedRow?.subscription)
                                                     ? selectedRow?.subscription.join(", ")
                                                     : String(selectedRow?.subscription).replace(/[\[\]{}"]/g, "")}</CustomText>  </Box>
               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.paidAmount")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{/* {selectedRow?.paymentAmount} */}
           {formatNumber(selectedRow?.paymentAmount, true)}
</CustomText>  </Box>
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.companyUsers")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.maxEmployees}</CustomText>  </Box>

          {/* <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.availableQuota")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
300</CustomText>  </Box> */}
       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.duration")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.duration}</CustomText>  </Box>

               <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.activation")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"right" }}>
{selectedRow?.date}</CustomText>  </Box>
        
                       <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.expiry")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.expiray}</CustomText>  </Box>
       
               
      
        </Box>

   
           <Box sx={{display:"flex",alignItems:"center",gap:1}}>
                   <CustomText sx={{ ...textStyles.h1, fontSize:18, fontWeight: 600, color: "#000000",textAlign:"left" }}>
            {t("commissionDetails.commissionDetails")}
                            </CustomText>
                          
                            </Box>
        <Box sx={{ border: '1px solid #E4E6EF', borderRadius: 2, p: 2,mt:2, backgroundColor: '#fff', mb: 3 }}>
        
          
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <CustomText sx={{ ...textStyles.h1, fontSize: 16, fontWeight: 400, color: "#5E5C5C", textAlign: "left" }}>
   {t("commissionDetails.status")}
  </CustomText>

                                            <Box sx={{ pointerEvents: "none" }}>
      <StatusDropdown
      currentStatus={selectedRow?.status|| "pending"}
      />
    </Box>
</Box>
        
           <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.commissionPercent")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
{selectedRow?.commission}</CustomText>  </Box>
              <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center",mb:2}}>
      <CustomText sx={{ ...textStyles.h1, fontSize:16, fontWeight: 400, color: "#5E5C5C",textAlign:"left" }}>
{t("commissionDetails.amount")}</CustomText>
     <CustomText sx={{ ...textStyles.h1, fontSize:15, fontWeight: 400, color: "#172B4D",textAlign:"left" }}>
  {formatNumber(selectedRow?.paymentAmount, true)}</CustomText>  </Box>
</Box> 
      </Box>
    </Drawer>
  );
};

export default CommissionDetails;